import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'mvs-display-message-before-result',
    templateUrl: './mvs-display-message-before-result.component.html',
    styleUrls: ['./mvs-display-message-before-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MvsDisplayMessageBeforeResultComponent {


}
